import { render, staticRenderFns } from "./MaterialsProfile.vue?vue&type=template&id=d8b3fd12"
import script from "./MaterialsProfile.vue?vue&type=script&lang=js"
export * from "./MaterialsProfile.vue?vue&type=script&lang=js"
import style0 from "./MaterialsProfile.vue?vue&type=style&index=0&id=d8b3fd12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports